import { Component, ViewChild } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { IUserModel } from 'src/app/core/models/masters/user-master.model';
import { MatDrawer } from '@angular/material/sidenav';
import { GenericService } from 'src/app/infrastructure/infrastructure-services/services/base/generic-service';
import { GenericEntryForm } from 'src/app/infrastructure/infrastructure-services/generics/genericentryform/generic-entry-form';
import { MatDialog } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { HeaderComponent } from '../header/header.component';

@Component({
  selector: 'app-left-side-menu',
  templateUrl: './left-side-menu.component.html',
  styleUrls: ['./left-side-menu.component.css'],
})
export class LeftSideMenuComponent extends GenericEntryForm<any, any> {
  getToken!: any;
  getloginDate!: any;
  getModuleSecret!: any;
  getModuleId!: any;
  getGuids!: any;
  getRedirectURL!: any;
  public isExpanded = true;
  isRouter: any;
  isMenu: string = '';
  isSubMenu: string = '';
  roleMenus: any = new Array();
  menuData: any = new Array();
  currentUserRoles: any = null;
  selectedMenu: string = "";
  dataFromApi: any;
  @ViewChild('drawer', { static: false }) public drawer !: MatDrawer;
  @ViewChild('header') public header !: HeaderComponent;
  menuList: any;
  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result) => result.matches),
      shareReplay()
    );
  isSidebarShown: boolean = false;
  activeMenuIndex: number = 0;

  constructor(
    private breakpointObserver: BreakpointObserver,
    dialog: MatDialog,
    router: Router,
    agenericRepository: GenericService<IUserModel>
  ) {
    super(agenericRepository, router, dialog);
    this.isRouter = router;
    this.currentUserRoles = sessionStorage.getItem('roleMenus');

    this.currentUserRoles = JSON.parse(this.currentUserRoles);

    // this.router.events.subscribe(res => {
    //   if(res instanceof NavigationEnd) {
    //     if (this.drawer._animationState == 'open' && this.isSidebarShown) {
    //      this.isSidebarShown = false;
    //      this.drawer.toggle(); 
    //     }   
    //   }
    // })

    //this.currentUserRoles = JSON.parse(this.currentUserRoles);
    console.log('currentUserRoles', this.currentUserRoles);
  }

  ngOnInit() {
    this.getMenus();
    this.dataFromApi = sessionStorage.getItem('data-from-api');
    this.computeActiveIndex();
  }

  tempMenuData: any = [{ menuGuId: '' }];
  drawerToggle(value: Array<any>) {
    if (value.length == 0) {
      //this.router.navigate(['/dashboardEntryform']);
      let rleType: any = sessionStorage.getItem('roleType');

      this.navigateBasedOnRole(rleType)
      this.menuData = value;
      this.activeMenuIndex = 0;
      if (this.drawer._animationState == 'open') {
        this.drawer.toggle();
      }
      if (this.isSidebarShown) {
        setTimeout(() => {
          this.header.sidebarShown = false;
          this.isSidebarShown = false;
        }, 500)
      }
      return;
    }
    this.menuData = value;
    if (!this.menuData.some((el: any) => (window.location.pathname.includes(el.menuParameter)))) {
      this.router.navigate([this.menuData.filter((menu: any) => menu.isActive)[0].menuParameter]);
      this.computeActiveIndex();
    }
    if (this.drawer._animationState == 'open') {
      return;
    }
    this.drawer.toggle();
  }
  makeActive(menus: any) {
    this.selectedMenu = menus;
  }

  computeActiveIndex() {
    setTimeout(() => {
      this.roleMenus.forEach((item: any, index: any) => {
        if (item.roleMenuList.some((el: any) => window.location.href.includes(el.menuParameter))) {
          this.activeMenuIndex = index;
        }
      })
    }, 100)
  }

  checkItem(menu: any, items: any) {
    if (menu.menuName == "Dashboard") {
      menu.roleMenuList = [];
      return true;
    }
    return items.filter((res: any) => res.isActive).length
  }




  public getMenus() {
    this.roleMenus = this.currentUserRoles?.roleMenuList;
  }

  public isActive(path: string) {

    return window.location.href.includes(path);
  }

  toggleSubMenu() {
    this.drawer.toggle();
    setTimeout(() => {
      this.header.sidebarShown = false;
      this.isSidebarShown = false;
    }, 500)
  }


  navigateBasedOnRole(roleType: string) {

    if (roleType === 'Vendor') {
      this.router.navigate(['/vendor-dashboard']);
    } else if (roleType === 'Customer') {
      this.router.navigate(['/customer-dashboard']);
    } else {
      this.router.navigate(['/dashboard']);
    }
  }
}
